import { Controller } from "@hotwired/stimulus"

// Mobile web's Compare, Find dupes and Share row under the title. Once it
// scrolls off the top, a pinned bar that also names the product takes over.
export default class extends Controller {
  static targets = ["inline", "pinned"]
  static values = { compareButtonId: String }

  connect() {
    this.observer = new IntersectionObserver(([entry]) => {
      this.pin(!entry.isIntersecting && entry.boundingClientRect.top < 0)
    })
    this.observer.observe(this.inlineTarget)
  }

  disconnect() {
    this.observer?.disconnect()
  }

  // Opens the section bar's comparison drawer, so one drawer holds the frame
  compare() {
    document.getElementById(this.compareButtonIdValue)?.click()
  }

  pin(pinned) {
    this.pinnedTarget.toggleAttribute("data-visible", pinned)
    this.pinnedTarget.inert = !pinned
  }
}
